import { getExperts } from 'api/expert';
import * as creatorsSync from 'actions/creatorsSync';
import { MAX_QUERY_EXPERTS } from 'constants/limits';
import { handleError } from 'services/ErrorService/ErrorService';

export const asyncHydrateExpertsForQueueComponent = () => async (dispatch) => {
  const params = {
    limit: MAX_QUERY_EXPERTS,
    isActive: true,
  };

  try {
    const { experts } = await getExperts(params);
    dispatch(creatorsSync.hydrateExperts(experts));
  } catch (error) {
    handleError({ error, showPopup: true });
  }
};
